module.exports = __webpack_public_path__ + "img/google_step_1.bc3fd372.jpg";